<form [formGroup]="formGroup()" class="row gap-4">
<!--  @if (apiInterface()) {-->
<!--    &lt;!&ndash; API INTERFACE &ndash;&gt;-->
<!--    <div class="col-sm-12">-->
<!--      <app-read-only-input [label]="'API_INTERFACES.API_INTERFACE'"-->
<!--                           [value]="apiInterface()"></app-read-only-input>-->
<!--    </div>-->
<!--  }-->
  <!-- CUSTOMER -->
  <div class="col-sm-12">
    <app-link-select
      [label]="'CUSTOMERS.CUSTOMER'"
      [controlName]="'customer'"
      [formGroup]="formGroup()"
      [optionLabelSelector]="[{ selector: 'company' }]"
      [optionValueSelector]="'id'"
      [baseLink]="'customers'"
      [searchValueName]="'company'"
      [isRequired]="true"
      [queryParams]="[]"
      [searchService]="customerService"
      [id]="'customer'"
    ></app-link-select>
  </div>
</form>
